export const ChevronLeft = () => (
  <path
    d='M15.0007 15.8499L11.1207 11.9699L15.0007 8.08991C15.1645 7.89861 15.2501 7.65253 15.2404 7.40086C15.2307 7.14918 15.1263 6.91044 14.9483 6.73235C14.7702 6.55425 14.5314 6.44992 14.2797 6.4402C14.0281 6.43048 13.782 6.51608 13.5907 6.67991L9.00069 11.2699C8.81444 11.4573 8.7099 11.7107 8.7099 11.9749C8.7099 12.2391 8.81444 12.4925 9.00069 12.6799L13.5907 17.2699C13.7781 17.4562 14.0315 17.5607 14.2957 17.5607C14.5599 17.5607 14.8133 17.4562 15.0007 17.2699C15.1859 17.08 15.2896 16.8252 15.2896 16.5599C15.2896 16.2946 15.1859 16.0398 15.0007 15.8499Z'
    fill='currentColor'
  />
)
